import type { ObjectKeys } from "~/@types/generics"

export const easings = {
  easeOutQuad: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  easeInQuad: "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
  easeInOutAccordion: "cubic-bezier(0.85, 0.0, 0.15, 1.0)",
} as const

export type Easings = ObjectKeys<typeof easings>
